import React from "react";
import { SiteConfig } from "../interfaces/ConfigInterface";

interface EmployeeSyncModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (employeeAltID: string, employeeAltLocationID: string) => void;
    config: SiteConfig; // Add config prop
}

const EmployeeSyncModal: React.FC<EmployeeSyncModalProps> = ({ isOpen, onClose, onSubmit, config }) => {
    const [employeeAltID, setEmployeeAltID] = React.useState("");
    const [employeeAltLocationID, setEmployeeAltLocationID] = React.useState("");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // If employeeSyncShowCompany is false, pass empty string for employeeAltLocationID
        const companyID = config.employeeSyncShowCompany ? employeeAltLocationID : "";
        onSubmit(employeeAltID, companyID);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="emp-sync-modal-overlay">
            <div className="emp-sync-modal">
                <div className="emp-sync-modal-header">
                    <h2>New Employee Sync</h2>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="emp-sync-modal-text-input">
                        <label>Employee ID:</label>
                        <input
                            type="text"
                            value={employeeAltID}
                            onChange={(e) => setEmployeeAltID(e.target.value)}
                            style={{ width: "100%", backgroundColor: "#D6E8FF" }}
                            required
                        />
                    </div>
                    {config.employeeSyncShowCompany && (
                        <div className="emp-sync-modal-text-input">
                            <label>Company ID:</label>
                            <input
                                type="text"
                                value={employeeAltLocationID}
                                onChange={(e) => setEmployeeAltLocationID(e.target.value)}
                                style={{ width: "100%", backgroundColor: "#D6E8FF" }}
                                required
                            />
                        </div>
                    )}
                    <div className="emp-sync-form-actions">
                        <button type="button" onClick={onClose}>Cancel</button>
                        <button type="submit">Sync</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmployeeSyncModal;

// Add CSS styles directly in this file using a template literal
const styles = `
.emp-sync-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.emp-sync-modal {
    background: white;
    border-radius: 12px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.3s ease-in-out;
    overflow: auto;
    scrollbar-width: thin;
}

.emp-sync-modal::-webkit-scrollbar {
    display: none;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.emp-sync-modal-header {
    background-color: #007bff;
    padding: 20px;
    color: white;
    text-align: center;
}

.emp-sync-modal-header h2 {
    margin: 0;
    font-size: 24px;
}

.emp-sync-modal form {
    padding: 20px;
}

.emp-sync-modal form div {
    margin-bottom: 5px;
}

.emp-sync-modal form label {
    display: block;
    font-size: 14px;
    color: #555;
    font-weight: 500;
}

.emp-sync-modal form input[type="text"] {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 14px;
    color: #333;
    background-color: #D6E8FF;
    transition: border-color 0.3s ease;
}

.emp-sync-modal form input[type="text"]:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

.emp-sync-form-actions {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    gap: 10px;
}

.emp-sync-form-actions button {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.emp-sync-form-actions button[type="submit"] {
    background-color: #007bff;
    color: white;
}

.emp-sync-form-actions button[type="submit"]:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
}

.emp-sync-form-actions button[type="button"] {
    background-color: #f0f0f0;
    color: #333;
}

.emp-sync-form-actions button[type="button"]:hover {
    background-color: #ddd;
    transform: translateY(-1px);
}

.emp-sync-form-actions button:active {
    transform: translateY(0);
}

.emp-sync-modal-text-input{
    margin-bottom: 20px;
}

.emp-sync-modal-text-input label{
    font-size: 14px;
    color: #555;
    text-align: center;
    margin-bottom: 5px;
}

.emp-sync-modal-text-input input{
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 14px;
    color: #333;
    background-color: #D6E8FF;
}

`;

const styleTag = document.createElement('style');
styleTag.innerHTML = styles;
document.head.appendChild(styleTag);
